import { createSelector } from '@ngrx/store';
import { delay, of } from 'rxjs';
import { v4 as uuid } from 'uuid';

import * as fromCore from './core.selectors';

export const selectMessagesView = createSelector(fromCore.selectMessages, messages => ({
    messages: messages.map(message => ({
        ...message,
        fadeOut: message.fadeOut ? of(true).pipe(delay(2000)) : of(false),
        id: message.id || uuid(),
    })),
}));
